export const PRODUCTION_UNITS_RESET_STATE = 'PRODUCTION_UNITS_RESET_STATE';
export const PRODUCTION_UNITS_CURRENT_ITEM = 'PRODUCTION_UNITS_CURRENT_ITEM';

export const PRODUCTION_UNITS_REQUEST_LOADING = 'PRODUCTION_UNITS_REQUEST_LOADING';
export const PRODUCTION_UNITS_REQUEST_SUCCESS = 'PRODUCTION_UNITS_REQUEST_SUCCESS';
export const PRODUCTION_UNITS_REQUEST_FAILED = 'PRODUCTION_UNITS_REQUEST_FAILED';

export const PRODUCTION_UNITS_CURRENT_ACTION = 'PRODUCTION_UNITS_CURRENT_ACTION';
export const PRODUCTION_UNITS_RESET_ACTION = 'PRODUCTION_UNITS_RESET_ACTION';